import React, { Component } from 'react';

class EventType extends Component {
  render() {
    const type = this.props.type;
    let CLASS = '';

    switch (type) {
      case 'in':
        CLASS = 'fa fa-arrow-left green';
        break;

      case 'out':
        CLASS = 'fa fa-arrow-right red';
        break;

      case 'pen':
        CLASS = 'fa fa-futbol-o pen';
        break;

      case 'goal':
        CLASS = 'fa fa-futbol-o';
        break;

      default:

    }

    return(
      <i className={CLASS!=='' ? CLASS : type}></i>
    )
  }
};

export default EventType;


// WEBPACK FOOTER //
// ./src/Components/EventType.js